"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BatchSet = _interopRequireDefault(require("../modules/BatchSet.vue"));
var _GoodsAttrbuit = _interopRequireDefault(require("../modules/GoodsAttrbuit.vue"));
var _common = require("../common");
var _api = require("../api");
var _MainImage = _interopRequireDefault(require("../modules/MainImage.vue"));
var _enum = require("../../enum");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var couponApi = _interopRequireWildcard(require("@/views/marketing/coupon/api"));
var _systemSetting = require("@/api/systemSetting.js");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'SpecificationsAndInventory',
  components: {
    BatchSetVue: _BatchSet.default,
    GoodsAttrbuit: _GoodsAttrbuit.default,
    MainImageVue: _MainImage.default
  },
  props: {
    cloneForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      formConfig: _common.formConfig,
      comData: _common.comData,
      rules: _common.rules,
      isAddRule: false,
      addRuleForm: {},
      selectRuleList: [],
      form: {},
      ID: this.$route.params.id,
      lock: true,
      goodsStatusEnum: _enum.goodsStatusEnum,
      cpStatusEnum: _enum.cpStatusEnum,
      couponSkuInfo: {},
      couponList: [],
      userType: null // 用户类型
    };
  },
  computed: {
    isCouponStockLocked: function isCouponStockLocked() {
      return this.cloneForm.productType == 3 && !!this.couponSkuInfo.couponId;
    },
    couponRules: function couponRules() {
      return (0, _common.createCouponSkuRules)(this);
    }
  },
  watch: {
    form: {
      handler: function handler(newVal, oldVal) {
        this.$emit('formChange', newVal);
        // console.log('form changed:', newVal, oldVal);
        // 在这里编写你需要的逻辑
      },
      deep: true
    },
    cloneForm: {
      handler: function handler(newForm) {
        this.form = _objectSpread({}, newForm);
        if (this.ID && this.form.attr && this.lock) {
          this.lock = false;
          this.selectRuleList = this.form.attr.map(function (item) {
            var _item$attrValues;
            return {
              value: item.attrName,
              detail: item === null || item === void 0 ? void 0 : (_item$attrValues = item.attrValues) === null || _item$attrValues === void 0 ? void 0 : _item$attrValues.split(','),
              inputVisible: false
            };
          });
        }
        ;
        if (newForm.productType == 3) {
          var _ref = newForm || {},
            _ref$attrValue = _ref.attrValue,
            attrValue = _ref$attrValue === void 0 ? [] : _ref$attrValue;
          this.couponSkuInfo = _objectSpread(_objectSpread({
            couponId: newForm === null || newForm === void 0 ? void 0 : newForm.couponId
          }, (attrValue === null || attrValue === void 0 ? void 0 : attrValue.length) && attrValue[0]), this.couponSkuInfo);
        }
      }
    },
    selectRuleList: {
      handler: function handler() {
        this.createAttrProps();
        this.createAttrValue();
        this.submitAttr();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
    this.searchCoupon();
  },
  methods: {
    throttle: _throttle.default,
    getRule: _common.getRule,
    validate: function validate() {
      var formRef = this.cloneForm.productType == 3 ? 'couponFormRef' : 'normalFormRef';
      return _common.validate.call(this, formRef);
    },
    confirm: function confirm() {
      this.selectRuleList = _toConsumableArray(this.form.selectRule.ruleValue);
    },
    handleInputConfirm: function handleInputConfirm(item) {
      item.inputValue && item.detail.indexOf(item.inputValue) === -1 && item.detail.push(item.inputValue);
      this.$set(item, 'inputVisible', false);
      this.$set(item, 'inputValue', '');
    },
    showInput: function showInput(index) {
      var _this2 = this;
      this.$set(this.selectRuleList[index], 'inputVisible', true);
      this.$nextTick(function () {
        _this2.$refs.saveTagInput[0].$refs.input.focus();
      });
    },
    handleTagNameClose: function handleTagNameClose(index) {
      this.selectRuleList.splice(index, 1);
    },
    handleTagClose: function handleTagClose(index, tagItem) {
      var target = this.selectRuleList[index].detail.indexOf(tagItem);
      this.selectRuleList[index].detail.splice(target, 1);
    },
    /**
     * 添加规格
     */
    addRule: function addRule() {
      var _this = this;
      var params = {
        ruleName: '',
        ruleValue: []
      };
      this.$modalAttr(params, function () {
        _this.getRule();
      });
    },
    addRuleItem: function addRuleItem() {
      var volidata = this.addRuleForm.attrName && this.addRuleForm.attrValue;
      if (!volidata) {
        this.$message.warning('请输入规格和规格值');
        return;
      }
      var newAttr = {
        inputVisible: false,
        value: this.addRuleForm.attrName,
        detail: [this.addRuleForm.attrValue]
      };
      if (this.ID) {
        var _this$selectRuleList;
        if ((_this$selectRuleList = this.selectRuleList) !== null && _this$selectRuleList !== void 0 && _this$selectRuleList.length) {
          this.selectRuleList.push(newAttr);
        } else {
          this.selectRuleList = [newAttr];
        }
      } else {
        var _this$form, _this$form$selectRule;
        this.form.selectRule.ruleValue.push(newAttr);
        this.selectRuleList = _toConsumableArray((_this$form = this.form) === null || _this$form === void 0 ? void 0 : (_this$form$selectRule = _this$form.selectRule) === null || _this$form$selectRule === void 0 ? void 0 : _this$form$selectRule.ruleValue);
      }
      this.addRuleForm.attrName = '';
      this.addRuleForm.attrValue = '';
      this.isAddRule = false;
    },
    clear: function clear() {
      this.selectRuleList = [];
    },
    clearInit: function clearInit() {
      this.couponSkuInfo = {};
    },
    /**
     * 求规格数组的笛卡儿积
     * @param arrays 规格数组
     */
    generateCombinations: function generateCombinations(attributes) {
      if (attributes.length === 0) {
        return [];
      }

      // 初始化结果数组
      var result = [];
      var isOneCardProduct = this.cloneForm.productType === 18;

      // 辅助函数，用于递归生成组合
      function helper(prefix, remainingAttrs) {
        if (remainingAttrs.length === 0) {
          // 当没有剩余属性时，结束递归并生成最终对象
          var stock = isOneCardProduct ? 0 : 9999;
          var stockWarning = isOneCardProduct ? 0 : 50;
          var combination = _objectSpread(_objectSpread({
            cpMinQuantity: 50,
            stock: stock,
            stockWarning: stockWarning,
            cpStatus: 3,
            listStatus: 1
          }, prefix), {}, {
            attrValue: _objectSpread({}, prefix)
          });
          result.push(combination);
          return;
        }

        // 取出第一个属性
        var _remainingAttrs = _toArray(remainingAttrs),
          firstAttr = _remainingAttrs[0],
          restAttrs = _arrayLikeToArray(_remainingAttrs).slice(1);

        // 遍历第一个属性的所有可能值
        firstAttr.detail.forEach(function (detail) {
          // 为每个可能值调用递归，以生成后续属性的组合
          helper(_objectSpread(_objectSpread({}, prefix), {}, _defineProperty({}, firstAttr.value, detail)), restAttrs);
        });
      }

      // 开始递归处理
      helper({}, attributes);
      return result;
    },
    createAttrProps: function createAttrProps() {
      var _this$$refs, _this$selectRuleList2;
      var _ref2 = ((_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.GoodsAttrbuitRef) || {},
        updataAttrProps = _ref2.updataAttrProps;
      var attrProps = (_this$selectRuleList2 = this.selectRuleList) === null || _this$selectRuleList2 === void 0 ? void 0 : _this$selectRuleList2.map(function (item) {
        return {
          label: item.value,
          prop: item.value // 历史原因此处是中文
        };
      });
      updataAttrProps && updataAttrProps(attrProps);
    },
    createAttrValue: function createAttrValue() {
      var compose = this.generateCombinations(this.selectRuleList);
      this.$set(this.form, 'attrValue', this.ID ? this.getNewAttrValue(compose) : compose);
      this.getSkuCodeColum();
    },
    getNewAttrValue: function getNewAttrValue(compose) {
      var _this3 = this;
      var result = [];
      var attrValues = this.form.attrValue.map(function (item) {
        return JSON.stringify(item.attrValue);
      });
      compose.forEach(function (item) {
        var index = attrValues.indexOf(JSON.stringify(item.attrValue));
        if (index === -1) {
          result.push(item);
        } else {
          result.push(_this3.form.attrValue[index]);
        }
      });
      return result;
    },
    //获取sku编码
    getSkuCodeColum: function () {
      var _getSkuCodeColum = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var spuCode, list, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              spuCode = this.form.spuCode;
              list = this.form.attrValue.map(function (item) {
                var attributeName = '';
                for (var key in item.attrValue) {
                  attributeName = "".concat(attributeName).concat(item.attrValue[key]);
                }
                return {
                  spuCode: spuCode,
                  attributeName: attributeName
                };
              });
              _context.p = 1;
              _context.n = 2;
              return (0, _api.buchGenerateSKUCodeApi)({
                list: list
              });
            case 2:
              res = _context.v;
              this.form.attrValue = this.form.attrValue.map(function (j, i) {
                return _objectSpread(_objectSpread({}, j), {}, {
                  skuCode: "".concat(res[i].code).concat(res[i].extraNum)
                });
              });
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error(_t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function getSkuCodeColum() {
        return _getSkuCodeColum.apply(this, arguments);
      }
      return getSkuCodeColum;
    }(),
    updataAttrValue: function updataAttrValue(data) {
      var _this4 = this;
      // 只更新有值的数据
      this.form.attrValue = this.form.attrValue.map(function (item) {
        for (var key in data) {
          if (_this4.cloneForm.productType === 18 && _this4.ID && key === 'stock') {
            continue;
          }
          if (data[key] || data[key] === 0) {
            if (key == 'image') {
              var _data$image;
              item.image = (_data$image = data['image']) !== null && _data$image !== void 0 && _data$image.length ? data['image'] : item.image;
            } else {
              _this4.$set(item, key, data[key]);
            }
          }
        }
        return item;
      });
    },
    submitAttr: function submitAttr() {
      var _this$selectRuleList3;
      this.form.attr = (_this$selectRuleList3 = this.selectRuleList) === null || _this$selectRuleList3 === void 0 ? void 0 : _this$selectRuleList3.map(function (item) {
        var _item$detail;
        return _objectSpread(_objectSpread({}, item), {}, {
          attrName: item.value,
          attrValues: (_item$detail = item.detail) === null || _item$detail === void 0 ? void 0 : _item$detail.join(',')
        });
      });
    },
    searchCoupon: function searchCoupon() {
      var _this5 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.couponList = [];
      couponApi.couponslistApi({
        page: 1,
        limit: 50,
        name: keyword
      }).then(function (res) {
        _this5.couponList = (res === null || res === void 0 ? void 0 : res.list) || [];
        if (_this5.couponSkuInfo.couponId) {
          var selectedCoupon = _this5.couponList.find(function (item) {
            return item.id === _this5.couponSkuInfo.couponId;
          });
          if (selectedCoupon) {
            _this5.applyCouponInventory(selectedCoupon);
            _this5.$set(_this5.form, 'isIntegralExchange', selectedCoupon.isIntegralExchange === 1 || selectedCoupon.isIntegralExchange === true ? 1 : 0);
          }
        }
      });
    },
    handleCouponSearch: function handleCouponSearch(data) {
      var _this6 = this;
      this.throttle(function () {
        _this6.searchCoupon(data);
      }, 300)();
    },
    attrImage: function attrImage() {
      var _this = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _this.$set(_this.couponSkuInfo, 'attrImage', data[0].sattDir);
      });
    },
    handleMainImage: function handleMainImage() {
      this.$refs.mainImageRef.open(this.couponSkuInfo.image);
    },
    mainImageList: function mainImageList(data) {
      this.$set(this.couponSkuInfo, 'image', data);
    },
    changeCoupon: function () {
      var _changeCoupon = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this7 = this;
        var selectedCoupon;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              selectedCoupon = this.couponList.find(function (item) {
                return item.id === _this7.couponSkuInfo.couponId;
              }); // 将选中消费券的积分兑换标识同步到 form，供后续步骤（分销授权）判断
              this.$set(this.form, 'isIntegralExchange', (selectedCoupon === null || selectedCoupon === void 0 ? void 0 : selectedCoupon.isIntegralExchange) || 0);
              if (this.couponSkuInfo.couponId) {
                _context2.n = 1;
                break;
              }
              this.searchCoupon();
              return _context2.a(2);
            case 1:
              if (selectedCoupon) {
                this.applyCouponInventory(selectedCoupon);
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function changeCoupon() {
        return _changeCoupon.apply(this, arguments);
      }
      return changeCoupon;
    }(),
    getCouponAvailableStock: function getCouponAvailableStock(coupon) {
      var totalQuantity = Number((coupon === null || coupon === void 0 ? void 0 : coupon.totalQuantity) || 0);
      var receiveCount = Number((coupon === null || coupon === void 0 ? void 0 : coupon.receiveCount) || 0);
      return Math.max(totalQuantity - receiveCount, 0);
    },
    applyCouponInventory: function applyCouponInventory(coupon) {
      this.$set(this.couponSkuInfo, 'stock', this.getCouponAvailableStock(coupon));
    },
    // 规格图片上传前的校验
    beforeAttrImageUpload: function beforeAttrImageUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！');
        return false;
      }
      return true;
    },
    // 处理规格图片本地上传
    handleAttrImageUpload: function () {
      var _handleAttrImageUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(options) {
        var file, formData, params, loading, res, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              file = options.file;
              formData = new FormData();
              formData.append('multipart', file);
              params = {
                model: 'product',
                pid: this.ID || 0
              };
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context3.p = 1;
              _context3.n = 2;
              return (0, _systemSetting.fileImageApi)(formData, params);
            case 2:
              res = _context3.v;
              loading.close();
              if (res && res.url) {
                this.$set(this.couponSkuInfo, 'attrImage', res.url);
                this.$message.success('规格图片上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              loading.close();
              this.$message.error('上传失败：' + (_t2.message || '请重试'));
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function handleAttrImageUpload(_x) {
        return _handleAttrImageUpload.apply(this, arguments);
      }
      return handleAttrImageUpload;
    }(),
    // 主图上传前的校验
    beforeMainImageUpload: function beforeMainImageUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！');
        return false;
      }
      return true;
    },
    // 处理主图本地上传
    handleMainImageLocalUpload: function () {
      var _handleMainImageLocalUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(options) {
        var file, formData, params, loading, res, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              file = options.file;
              formData = new FormData();
              formData.append('multipart', file);
              params = {
                model: 'product',
                pid: this.ID || 0
              };
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context4.p = 1;
              _context4.n = 2;
              return (0, _systemSetting.fileImageApi)(formData, params);
            case 2:
              res = _context4.v;
              loading.close();
              if (res && res.url) {
                // 添加到主图列表
                if (this.couponSkuInfo.image && this.couponSkuInfo.image.length > 0) {
                  this.couponSkuInfo.image.push(res.url);
                } else {
                  this.$set(this.couponSkuInfo, 'image', [res.url]);
                }
                this.$message.success('主图上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              loading.close();
              this.$message.error('上传失败：' + (_t3.message || '请重试'));
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function handleMainImageLocalUpload(_x2) {
        return _handleMainImageLocalUpload.apply(this, arguments);
      }
      return handleMainImageLocalUpload;
    }()
  }
};